"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSaleProxyContract = exports.useSaleContract = void 0;
var abi_1 = require("../abi");
var useContract_1 = require("../contracts/useContract");
function useSaleContract(config, web3) {
    return (0, useContract_1.useContract)(abi_1.CONTRACTS.sale['v3'].abi, config.sale.address, web3);
}
exports.useSaleContract = useSaleContract;
function getSaleProxyContract(web3) {
    if (!web3)
        return undefined;
    return new web3.eth.Contract(abi_1.CONTRACTS.saleProxy.v1.abi, abi_1.CONTRACTS.saleProxy.v1.address);
}
exports.getSaleProxyContract = getSaleProxyContract;
